<template>
  <div class="title-box" :class="topic">
    <h1 class="main-title" v-html="titleInfo.mainTitle"></h1>
    <h2 class="sub-title">{{ titleInfo.subTitle }}</h2>
  </div>
</template>

<script>
export default {
  props: ['titleInfo', 'topic']
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.title-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 80px 0 40px 0;
  &.white {

    .main-title {
      color: #fff;
      &::after {
        background: #fff;
      }
    }

    .sub-title {
      color: #fff;
    }
  }
  .main-title {
    position: relative;
    margin-bottom: 16px;
    padding-bottom: 16px;
    color: $font-color1;
    line-height: 1;
    font-size: $fontSize30;
    font-weight: 600;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 53px;
      height: 4px;
      border-radius: 2px;
      background: $primary1;
    }
  }
  .sub-title {
    color: $font-color2;
    line-height: 1;
    font-size: $fontSize18;
    font-weight: 400;
  }
}

@include mobile {
  .title-box {
    padding: 40px 0 20px 0;
    .main-title {
      font-size: 23px;
      margin-bottom: 8px;
      padding-bottom: 12px;
    }
    .sub-title {
      font-size: 16px;
      line-height: 1.4;
    }
  }
}
</style>
